<template>
  <div
    v-if="!isTooltip"
    :class="computedClass"
  >
    {{ handleColumnValue(value) }}
  </div>
  <v-tooltip
    v-else
    top
  >
    <template v-slot:activator="{on, attrs}">
      <span
        v-bind="attrs"
        v-on="on"
      >
        {{ handleColumnValue(value) }}
      </span>
    </template>
    <span class="hideOverflow">{{ value }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'DataTableTextColumn',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          shouldWrap: true,
        };
      },
    },
    header: {
      type: Object,
      default: null,
    },
    showAllContent: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedClass() {
      return {
        noWrap: this.isWrap,
      };
    },
    isWrap() {
      const { options } = this;
      return options ? options.shouldWrap : true;
    },
    isTooltip() {
      return this.header && this.header.tooltip && this.showAllContent;
    },
  },
  inject: {
    handleColumnValue: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>

<style scoped>
.hideOverflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100px;
}
</style>
